import { render, staticRenderFns } from "./PrintTemplatesList.vue?vue&type=template&id=3f27c475&"
import script from "./PrintTemplatesList.vue?vue&type=script&lang=js&"
export * from "./PrintTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports